import { faArrowRight } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ButtonLink } from 'components/shared/ButtonLink';
import { useI18n } from 'hooks/useI18n';
import { useRouter } from 'next/dist/client/router';
import Link from 'next/link';
import ServiceEventTracking from 'services/service.event-tracking';
import { APP_URLS, getAppUrl } from 'utils/app-urls';
import { getPublicPath } from 'utils/paths';
import {
  StyledHero,
  StyledHeroContainer,
  StyledHeroImage,
  StyledHeroText,
  StyledHeroTitle
} from './CompassHero.styled';

const CompassHero: React.FC = () => {
  const { t } = useI18n('salary-compass');
  const { locale } = useRouter();

  return (
    <StyledHero>
      <StyledHeroContainer>
        <StyledHeroText>
          <StyledHeroTitle>{t('salary-compass.hero.title')}</StyledHeroTitle>
          <p
            dangerouslySetInnerHTML={{
              __html: t('salary-compass.hero.desc')
            }}
          ></p>
          <Link
            href={`${getAppUrl(
              APP_URLS.join,
              locale
            )}?locale={locale}&source=unete-hero-brujula&returnUrl=${getAppUrl(
              APP_URLS.salaryBenchmark,
              locale
            )}`}
            passHref
          >
            <ButtonLink
              variant="brandTalent"
              onClick={(e) =>
                ServiceEventTracking.trackExternalLandingCtaClicked(
                  e,
                  `${getAppUrl(
                    APP_URLS.join,
                    locale
                  )}?locale=${locale}&source=unete-hero-brujula`,
                  'unete-hero-brujula'
                )
              }
            >
              <span>{t('salary-compass.hero.cta')}</span>
              <FontAwesomeIcon icon={faArrowRight} />
            </ButtonLink>
          </Link>
        </StyledHeroText>
        <StyledHeroImage>
          <img
            src={getPublicPath('/images/salaryCompass/salary-benchmark.png')}
            alt=""
          />
        </StyledHeroImage>
      </StyledHeroContainer>
    </StyledHero>
  );
};

export default CompassHero;
